import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=09655f4b&scoped=true"
var script = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=09655f4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09655f4b",
  null
  
)

export default component.exports